import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plant_insect",
  "use": "icon-plant_insect-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plant_insect\"><path d=\"M529.216 369.024a16 16 0 0 1 11.04 25.312 64 64 0 0 0 89.408 89.408 16 16 0 0 1 25.312 11.04 144 144 0 1 1-125.76-125.76zM512 800a288 288 0 1 1 0-576 288 288 0 0 1 0 576z m0-64a224 224 0 1 0 0-448 224 224 0 0 0 0 448z\" fill=\"#000000\" p-id=\"5895\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol